import React from "react";

const GrainOverlay = () => {
    return <div className="grain" aria-hidden="true" />;
};

export default GrainOverlay;
